/**
 * Rapsodo surface descriptor — feeds into renderSessionSurface (src/ui/session-surface.js).
 *
 * Sibling to source.js (ingest descriptor). Same pattern, different concern:
 * source.js describes how to ingest a CSV; surface.js describes how to render
 * the dashboards section.
 */

import { aggregateRapsodoSessions } from '../../db/aggregation.js';
import { deleteRapsodoSession } from '../../db/queries.js';

export const rapsodoSurface = {
  // Section markers in renderDashboardsTab's HTML template.
  sectionId: '#rapsodo-section',
  tableId: '#rapsodo-sessions-table',
  chartWrapId: '#rapsodo-sessions-chart-wrap',
  pickerId: '#rapsodo-session-picker',
  detailId: '#rapsodo-detail',
  detailSubId: '#rapsodo-detail-sub',

  // Rapsodo has the date-range compare-button; PR doesn't.
  compareButtonId: '#compare-toggle',

  // Across-sessions chart variant.
  chartKind: 'rapsodo',

  // Per-pitch detail charts.
  detailCharts: [
    { containerId: '#athlete-trend',   tag: 'ta-trend',   rowsProp: 'pitches' },
    { containerId: '#athlete-heatmap', tag: 'ta-heatmap', rowsProp: 'pitches' },
  ],

  // Source-shaped functions.
  aggregate: aggregateRapsodoSessions,
  deleteSession: deleteRapsodoSession,

  // Source-specific copy.
  detailLabel: (session) => `${session.label} — per-pitch detail`,
  detailFallbackLabel: 'Per-pitch detail',
  deleteConfirmCopy: (label) =>
    `Delete "${label}"?\n\n` +
    `This permanently removes the upload, every pitch in it, the archived CSV, ` +
    `and the Files-tab entry. This can't be undone.`,
};
